import React from 'react';
import { Chip } from '@heroui/react';
import { Icon } from '@iconify/react';
import { SubscriberData } from '../types';

interface SubscriberUserCellProps {
  subscriber: SubscriberData;
}

const SubscriberUserCell: React.FC<SubscriberUserCellProps> = ({ subscriber }) => {
  const getPaymentChips = () => {
    const chips = [];

    // Добавляем чипы на основе данных
    if (subscriber.transactionsCount === 1) {
      chips.push(
        <Chip key="1-payment" size="sm" className="!bg-success/20 text-success" variant="flat">
          1 оплата
        </Chip>
      );
    }

    if (subscriber.more3ChatMessages === true) {
      chips.push(
        <Chip key="3-messages" size="sm" className="!bg-partner/20 text-partner" variant="flat">
          3 сообщения
        </Chip>
      );
    }

    if (parseFloat(subscriber.transactionsMaxAmount) >= 500) {
      chips.push(
        <Chip key="payment-500" size="sm" className="!bg-success/20 text-success" variant="flat">
          Оплата на 500$
        </Chip>
      );
    }

    // Добавляем чип подписки на основе количества транзакций
    if (subscriber.transactionsCount > 1) {
      chips.push(
        <Chip
          key="regular-subscription"
          size="sm"
          className="!bg-warning/20 text-warning"
          variant="flat"
        >
          Регулярная подписка
        </Chip>
      );
    } else if (subscriber.transactionsCount === 1) {
      chips.push(
        <Chip
          key="paid-subscription"
          size="sm"
          className="!bg-warning/20 text-warning"
          variant="flat"
        >
          Платная подписка
        </Chip>
      );
    }

    return chips;
  };

  return (
    <div className="flex flex-col gap-2">
      {/* Имя пользователя */}
      <a href={`https://onlyfans.com/${subscriber.ofUserId}`} target="__blank" className="">
        <div className="flex items-center gap-2">
          <span className="text-sm font-semibold text-default-900">{subscriber.name}</span>
          <Icon
            icon="solar:square-top-down-linear"
            width={12}
            height={12}
            className="text-partner"
          />
        </div>
      </a>
      {/* Чипы с типами оплат */}
      <div className="flex flex-wrap gap-1">{getPaymentChips()}</div>
    </div>
  );
};

export default SubscriberUserCell;
